export default 'Gds-Name'
